var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgZoomLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#zoom-logo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 12c0 1.283-.103 2.541-.3 3.768a9.602 9.602 0 0 1-7.932 7.932 23.742 23.742 0 0 1-7.536 0A9.602 9.602 0 0 1 .3 15.768a23.746 23.746 0 0 1 0-7.536A9.602 9.602 0 0 1 8.232.3a23.747 23.747 0 0 1 7.536 0A9.602 9.602 0 0 1 23.7 8.232c.197 1.226.3 2.485.3 3.768Z",
  fill: "#0B5CFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 12c0 1.283-.103 2.541-.3 3.768a9.602 9.602 0 0 1-7.932 7.932 23.742 23.742 0 0 1-7.536 0A9.602 9.602 0 0 1 .3 15.768a23.746 23.746 0 0 1 0-7.536A9.602 9.602 0 0 1 8.232.3a23.747 23.747 0 0 1 7.536 0A9.602 9.602 0 0 1 23.7 8.232c.197 1.226.3 2.485.3 3.768Z",
  fill: "url(#zoom-logo_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 12c0 1.283-.103 2.541-.3 3.768a9.602 9.602 0 0 1-7.932 7.932 23.743 23.743 0 0 1-7.536 0A9.602 9.602 0 0 1 .3 15.768a23.744 23.744 0 0 1 0-7.536A9.602 9.602 0 0 1 8.232.3a23.746 23.746 0 0 1 7.536 0A9.602 9.602 0 0 1 23.7 8.232c.197 1.226.3 2.485.3 3.768Z",
  fill: "url(#zoom-logo_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.571 15c0 .71-.575 1.286-1.285 1.286H7.714a2.571 2.571 0 0 1-2.571-2.572V9c0-.71.575-1.286 1.286-1.286H12a2.571 2.571 0 0 1 2.571 2.572V15Zm3.257-6.514L15.943 9.9a1.286 1.286 0 0 0-.514 1.028v2.143c0 .405.19.786.514 1.029l1.885 1.414a.643.643 0 0 0 1.03-.514V9a.643.643 0 0 0-1.03-.514Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "zoom-logo_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(16.1792 0 0 13.5222 12 10.605)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#0B5CFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#003CB3"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "zoom-logo_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(16.1734 0 0 13.5174 12 13.39)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#0B5CFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#71A5F1"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "zoom-logo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgZoomLogo;